// Export component.
export * from './components/Share/index';
export { Share as default } from './components/Share/index';
export { ShareNotification } from './components/ShareNotification/ShareNotification';

// Export interfaces.
export { default as IDefaultRecipients } from './interfaces/IDefaultRecipients';
export {
    IGetSharingInformationResponse, IPermissionsInformation, ISharingLinkFromAPI,
    ISharingPrincipalFromAPI, ISharingLinkAbilities, ISharingLinkAbilityStatus,
    ISharingLinkAbilitiesMatrix, ISharingInformation,
    ISharingItemInformation, ISharingLink, ISharingPrincipal,
    IShareLinkResult
} from './interfaces/SharingInterfaces';
export { default as IPolicyTipInformation } from './interfaces/IPolicyTipInformation';
export { ISharingContextInformation } from '@ms/odsp-datasources/lib/interfaces/sharing/SharingInterfaces';
export { default as ISharingLinkSettings } from './interfaces/ISharingLinkSettings';
export { default as ISharingStore, IShareLinkParams } from './interfaces/ISharingStore';

// Export enums.
export { default as AccessStatus } from './interfaces/enums/AccessStatus';
export {
    Error, Category, Mode, SharePermission,
    SharingAudience, SharingLinkKind, SharingRole,
    ClientId
} from './interfaces/SharingInterfaces';
export { default as OutlookAvailability } from './interfaces/enums/OutlookAvailability';
export { default as SharingCapabilityDisabledReason } from './interfaces/enums/SharingCapabilityDisabledReason';
